import { getDate } from "date-fns";
import React from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import './OrderSummary.css'
import { fixDateDirection } from "../../utils/orderUtils";
function OrderSummary(props) {
    const orderCart = useSelector(state => state.reducer);

    return <>
    {isMobile ? <div className="orderSummary">
                    <div className="gap-2 px-2 d-flex justify-content-start text-mahuti">
                        <span>{orderCart?.selectedActivity?.Title || '--'}</span>
                        <span>{orderCart?.activityDate}</span>
                    </div>
                    <div className="d-flex align-items-center px-2">
                        <div className="col d-flex justify-content-start text-mahuti">
                            {/* <span>ילד {orderCart?.visitors?.underAge || '--'} x</span>
                            <span>מבוגרי* {orderCart?.visitors?.adults || '--'}</span> */}
                            <span>{orderCart.visitors?.underAge || '--'} ילדים, {orderCart.visitors?.adults || '--'} מבוגרים</span>
                        </div>
                        <div className="col d-flex justify-content-end orderPayment">
                        לתשלום: {props.orderPayment}₪
                        </div>
                    </div>
                </div> :
                <div className="orderSummary card border-0 px-3 py-2 z-index-2 rounded-0">
                    <div className="card-body container">
                        <div className="row ">
                            <div className="col p-1 d-flex text-start card-title">סיכום רכישה</div>
                        </div>
                        <div className="row row-cols-2 border-bottom py-2">

                            {orderCart.selectedActivity && <>
                                <div className="col p-1 d-flex text-start header-detail">שם פעילות</div>
                                <div className="col p-1 d-flex justify-content-end text-mahuti">{orderCart.selectedActivity?.Title || '--'}</div>
                            </>
                            }

                            {(orderCart.visitors?.adults || orderCart.visitors?.underAge) ? <>
                                <div className="col p-1 d-flex text-start header-detail">כמות משתתפים</div>
                                <div className="col p-1 d-flex justify-content-end text-mahuti">
                                    {orderCart.visitors?.underAge || '--'} ילדים, {orderCart.visitors?.adults || '--'} מבוגרים
                                </div>
                            </>
                                : <></>
                            }


                            {orderCart.activityDate && <>
                                <div className="col p-1 d-flex text-start header-detail">תאריך הפעילות</div>
                                <div className="col p-1 d-flex justify-content-end text-mahuti">{fixDateDirection(String(orderCart.activityDate))}</div>
                            </>
                            }

                            {orderCart.selectedActivity?.timing && <>
                                <div className="col p-1 d-flex text-start header-detail">שעת הפעילות:</div>
                                <div className="col p-1 d-flex justify-content-end text-mahuti">{orderCart.selectedActivity?.timing?.endTime} - {orderCart.selectedActivity?.timing?.startTime}</div>
                            </>
                            }
                        </div>
                    </div>
                    <div className="card-footer bg-body border-0 d-flex justify-content-end header-detail">
                        <span>
                            סך הכל לתשלום: {props.orderPayment}₪
                        </span>
                    </div>
                </div>}
        
        
    </>


}


export default OrderSummary;